const styles = {
  tooltipContainer: {
    borderRadius: 10,
    padding: 10,
    boxShadow: '5px 10px 15px rgb(180, 176, 176)',
    backgroundColor: 'white'
  },
  tooltipArrow: {
    position: 'absolute',
    bottom: -8,
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '20px solid transparent',
    borderRight: '20px solid transparent',
    borderTop: '14px solid white'
  },
  emojiSubIcon:{
    width: 16, height: 16 
  },
  tooltipDataContainer: {
    borderRadius: 20,
    width: 450,
    display: 'flex',
    flexDirection: 'row',
    gap: 20,
    padding: 20
  },
  tooltipDivider: {
    border: '0.5px solid #DDE1E5',
    marginBottom: '10px'
  },
  tooltipName: {
    marginBottom: 10
  },
  tooltipFooter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  tooltipDetailsButton: {
    justifyContent: 'center',
    paddingVertical: 10
  },
  emojiContainer: {
    position: 'relative',
    width: 'fit-content',
    height: 'fit-content'
  },
  subEmojiContainer: {
    position: 'absolute',
    backgroundColor: 'white',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bottom: '0px',
    left: '0px',
    padding: '2px'
  }
};
export default styles;
